<template>
  <div class="tw-gap-4 tw-grid tw-grid-cols-2 lg:tw-max-w-[528px] lg:tw-m-auto">
    <TextField
      id="address1"
      v-model="address1"
      data-testid="address1"
      name="address1"
      rules="required|min:1|max:256"
      :placeholder="$t('forms.address.address_1_placeholder')"
      :label="$t('forms.address.address_1')"
      class="tw-col-span-2"
    />

    <TextField
      id="address2"
      v-model="address2"
      data-testid="address2"
      name="address2"
      rules="min:1|max:256"
      :placeholder="$t('forms.address.address_2_placeholder')"
      :label="$t('forms.address.address_2')"
      class="tw-col-span-2"
    />

    <TextField
      id="city"
      v-model="city"
      data-testid="city"
      name="city"
      rules="required|alpha_spaces|max:256"
      :placeholder="$t('forms.address.city_placeholder')"
      :label="$t('forms.address.city')"
      class="tw-col-span-2"
    />

    <StateField
      id="state"
      v-model="state"
      data-testid="state"
      name="state"
      rules="required"
      :placeholder="$t('forms.address.state_placeholder')"
      :label="$t('forms.address.state')"
      class="tw-col-span-2 xl:tw-col-span-1"
    />

    <TextField
      id="zip"
      v-model="zip"
      data-testid="zip"
      name="zip"
      rules="required|digits:5"
      :placeholder="$t('forms.address.zip_placeholder')"
      :label="$t('forms.address.zip')"
      class="tw-col-span-2 xl:tw-col-span-1"
    />
  </div>
</template>

<script>
import TextField from '~/components/form-fields/TextField'
import StateField from '~/components/form-fields/StateField'

export default {
  components: {
    TextField,
    StateField,
  },
  props: {
    values: {
      type: null,
      required: true,
    },
  },
  computed: {
    address1: {
      get() {
        return this.values.address1
      },
      set(value) {
        this.handleChange('address1', value)
      },
    },
    address2: {
      get() {
        return this.values.address2
      },
      set(value) {
        this.handleChange('address2', value)
      },
    },
    city: {
      get() {
        return this.values.city
      },
      set(value) {
        this.handleChange('city', value)
      },
    },
    state: {
      get() {
        return this.values.state
      },
      set(value) {
        this.handleChange('state', value)
      },
    },
    zip: {
      get() {
        return this.values.zip
      },
      set(value) {
        this.handleChange('zip', value)
      },
    },
  },
  methods: {
    handleChange(key, value) {
      const payload = this.values || {}
      this.$emit('on-change', { ...payload, [key]: value })
    },
  },
}
</script>
